export default __webpack_public_path__ + "static/media/blog2.8a154c0d.jpg";